export const ZONA_NAYARIT = "America/Bahia_Banderas";

const FMT = new Intl.DateTimeFormat("en-CA", {
  timeZone: ZONA_NAYARIT, year: "numeric", month: "2-digit", day: "2-digit",
});

export function hoyNayarit(ahora = new Date()) {
  return FMT.format(ahora);
}
